import Question from '../forms/Question';
import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import ErrorMessageBlock from '../ErrorMessageBlock.jsx';

let globalCheckKey = 0;

const AdminSchedulingQuestion = ({
    value,
    setValue,
    isUnavailable,
    setIsUnavailable,
    settings,
}) => {
    const { save: checkAvailable, isSaving: isCheckingAvailable } =
        useBusinessPostApi(
            `/schedule/check-available${settings?.ignoreEvents ? `?ignoreEvents=${JSON.stringify(settings.ignoreEvents)}` : ''}`,
            { allowConcurrentSaves: true },
        );
    const [unavailableErrorMessage, setUnavailableErrorMessage] = useState('');

    useEffect(() => {
        // Check if available!
        if (typeof value.forEach !== 'function') {
            return;
        }

        setIsUnavailable(false);
        const localCheckKey = (globalCheckKey = new Date().getTime());

        value.forEach(singleEventValue => {
            if (
                singleEventValue.startTime &&
                singleEventValue.bookableResource &&
                singleEventValue.eventType
            ) {
                checkAvailable(singleEventValue)?.then(result => {
                    // Just in case query is slow and we updated values and
                    //  have another check going at the same time
                    if (globalCheckKey === localCheckKey) {
                        setIsUnavailable(result.isUnavailable);
                        setUnavailableErrorMessage(result.message);
                    }
                });
            }
        });
    }, [JSON.stringify(value)]);

    return (
        <div>
            <Question
                isReadOnly={false}
                question={{
                    type: 'scheduling',
                    label: '',
                    settings: {
                        enableRecurring: true,
                        ...settings,
                        ...settings?.questionSettings,
                        allowCustomTime: true,
                        pooledAvailability: 'optional',
                        compact: true,
                    },
                }}
                value={value}
                setValue={setValue}
                id="scheduling"
            />

            {isUnavailable && (
                <ErrorMessageBlock className="mt-2 mb-2">
                    {unavailableErrorMessage}

                    <div className="mt-2">
                        You are permitted to schedule this because you are an
                        admin.
                    </div>
                </ErrorMessageBlock>
            )}
        </div>
    );
};

export default AdminSchedulingQuestion;
